import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { AdnginInContent } from '../components/AdnginInContent';
import ArchiveModeTag from '../components/ArchiveModeTag';
import RoundsNavigation from '../components/RoundsNavigation';
import { Spinner } from '../components/spinner/spinner';
import { TodaysCountryProvider } from '../providers/TodaysCountryProvider';
import { useUser } from '../providers/UserProvider';
import { clearArchiveLocalStorage, FIRST_ARCHIVE_DATE } from '../utils/archive';
import Round from './rounds/Round';

const dateRegex = /\d{4}-\d{2}-\d{2}$/;

const ArchiveDateRoute = () => {
  const { date } = useParams<{ date: string }>();
  const [loading, setLoading] = useState(true);
  const { userDetails, isLoaded } = useUser();
  const history = useHistory();

  useEffect(() => {
    if (!isLoaded) return;
    if (
      !date ||
      !dateRegex.test(date) ||
      !userDetails?.premiumGames?.includes('flagle')
    ) {
      history.replace('/archive');
      return;
    }

    const paramDate = dayjs(date);
    const today = dayjs();
    if (
      paramDate.isBefore(dayjs(FIRST_ARCHIVE_DATE), 'day') ||
      paramDate.isAfter(today, 'day')
    ) {
      history.replace('/archive');
    }

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      clearArchiveLocalStorage();
      setLoading(false);
    }, 500);
  }, [userDetails?.premiumGames, date, history, isLoaded]);

  return (
    <>
      {loading ? (
        <div className="flex items-center justify-center mt-8">
          <Spinner />
        </div>
      ) : (
        <TodaysCountryProvider
          dayString={dayjs(date).format('YYYY-MM-DD')}
          isArchive={true}
        >
          <ArchiveModeTag />
          <RoundsNavigation />
          <Round />
          {!userDetails?.premiumGames?.includes('flagle') && (
            <AdnginInContent />
          )}
        </TodaysCountryProvider>
      )}
    </>
  );
};

export default ArchiveDateRoute;
